export default "{{#if path}}\n    <img class=\"img-responsive\" src=\"{{join (global_var 'APP.settings.wkfgContentBaseUrl') path}}\"/>\n{{/if}}";